import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

const ParkSessionSkeleton = () => {
  return (
      <Swiper
        className="safari-carousel"
        loop={false}
        spaceBetween={0}
        navigation={false}
        slidesPerView={3}
        breakpoints={{
          0: { slidesPerView: 1 },
          600: { slidesPerView: 2 },
          900: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
        }}
      >
        {[1, 2, 3, 4].map((_, index) => (
          <SwiperSlide key={`skeleton-${index}`}>
            <div className="safari-box">
              <div className="image-box">
                <Skeleton height={600} />
              </div>

              <div className="content-box pt-2">
                <h3>
                  <Skeleton width={`80%`} height={20} />
                </h3>
              </div>

              <div className="overlay-content d-flex align-items-center justify-content-between mt-2">
                <div className="content_o pe-2" style={{ flex: 1 }}>
                  <h3>
                    <Skeleton width={`60%`} height={18} />
                  </h3>
                  <p>
                    <Skeleton count={2} />
                  </p>
                </div>
                <div className="link">
                  <Skeleton circle width={24} height={24} />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
   
  );
};

export default ParkSessionSkeleton;
